const title = {
  font: '"Helvetica Neue",Helvetica,Arial,sans-serif;',
};

export { title };
